export default function EmptyState({ title = 'Nada por aqui', description = 'Tente ajustar os filtros ou criar um novo registro.', action = null }) {
  return (
    <div className="w-full py-16 text-center">
      <div className="mx-auto w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center mb-4">
        <span className="text-2xl">✨</span>
      </div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
      <p className="text-gray-500 dark:text-gray-400 mt-1">{description}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
